import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { VaModal } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { toggleLoginModal } from 'platform/site-wide/user-nav/actions';
import recordEvent from 'platform/monitoring/record-event';
import { AUTHN_SETTINGS } from 'platform/user/authentication/constants';
import LoginContainer from './LoginContainer';

const focusSignInModalClose = () => {
  requestAnimationFrame(() => {
    document
      .getElementById('signin-signup-modal')
      ?.shadowRoot?.querySelector('.va-modal-close')
      ?.focus();
  });
};

export default function SignInModal() {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(toggleLoginModal(false));
  };
  const visible = useSelector(state => state?.navigation?.showLoginModal);
  const [prevVisible, setPrevVisible] = useState(null);

  useEffect(() => {
    if (!prevVisible && visible) {
      recordEvent({ event: 'login-modal-opened-oauth' });
      if (sessionStorage.getItem(AUTHN_SETTINGS.PASSKEY_FOCUS_CLOSE)) {
        sessionStorage.removeItem(AUTHN_SETTINGS.PASSKEY_FOCUS_CLOSE);
        focusSignInModalClose();
      }
    } else if (prevVisible && !visible) {
      recordEvent({ event: 'login-modal-closed-oauth' });
    }
    setPrevVisible(visible);
  }, [visible, prevVisible]);

  // When the browser restores this page from bfcache (back button), VaModal's
  // setupModal() doesn't re-run, so focus stays on the last clicked element.
  // Re-focus the close button if the modal was open when the page was cached.
  useEffect(() => {
    const handlePageShow = e => {
      if (e.persisted && visible) {
        focusSignInModalClose();
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, [visible]);

  return visible ? (
    <VaModal
      large
      visible={visible}
      onCloseEvent={onClose}
      id="signin-signup-modal"
      label="sign-in"
    >
      <LoginContainer />
    </VaModal>
  ) : null;
}
